import axios from "axios";

const http = axios.create({
    baseURL: "https://bhepl.com/api",
    // baseURL: "http://localhost:5000/api",
    headers: {
        "Content-type": "application/json",
    },
});

http.interceptors.request.use((config) => {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (user?.id) {
        config.headers["X-User-Id"] = user.id;
    }
    return config;
});

export default http;


export const ApiBaseUrl = "https://bhepl.com/api";
// export const ApiBaseUrl = "http://localhost:5000/api";
